/**
 * ServiceTriggerController
 * `.<block>-trigger[data-target]` のクリックで
 * 対応する `.<block>-content` の is-active を切り替える汎用タブコントローラ。
 *
 * HTML構造:
 * <div class="<block>">
 *   <div class="<block>__title">
 *     <p class="<block>-trigger" data-target="unique-id-a">...</p>
 *     <p class="<block>-trigger" data-target="unique-id-b">...</p>
 *   </div>
 *   <div class="<block>__body">
 *     <div class="<block>-content is-active" id="unique-id-a">...</div>
 *     <div class="<block>-content" id="unique-id-b">...</div>
 *   </div>
 * </div>
 *
 * 対応ブロック名は BLOCKS 配列で管理。追加ブロックはここに足すだけで良い。
 */
import { LenisController } from './lenis-controller';

const BLOCKS = [ 'service', 'visit-us' ];
// クリック時にブロック先頭へスクロールさせるブロック名。
// (visit-us は SP でトリガー同士が縦に離れているため、切替後に上端へ戻す)
const SCROLL_TO_BLOCKS = new Set( [ 'visit-us' ] );

export const ServiceTriggerController = {
  init() {
    BLOCKS.forEach( ( blockName ) => this.setup( blockName ) );
  },

  setup( blockName ) {
    const blocks       = document.querySelectorAll( `.${ blockName }` );
    const triggerClass = `${ blockName }-trigger`;
    const contentClass = `${ blockName }-content`;

    blocks.forEach( ( block ) => {
      const triggers = block.querySelectorAll( `.${ triggerClass }` );
      const contents = block.querySelectorAll( `.${ contentClass }` );
      // 補助パネル: content と同じ ID を data-panel-target に持つ任意要素も同期対象にする
      // （例: 左カラムの住所テキストなど、右カラムの content 画像と一緒に切り替えたい要素）
      const panels   = block.querySelectorAll( '[data-panel-target]' );
      if ( !triggers.length || !contents.length ) return;

      const activate = ( targetId ) => {
        triggers.forEach( ( t ) => {
          t.classList.toggle( 'is-active', t.dataset.target === targetId );
        } );
        contents.forEach( ( c ) => {
          c.classList.toggle( 'is-active', c.id === targetId );
        } );
        panels.forEach( ( p ) => {
          p.classList.toggle( 'is-active', p.dataset.panelTarget === targetId );
        } );
      };

      const initialActive = block.querySelector( `.${ contentClass }.is-active` );
      if ( initialActive ) {
        // 同じ data-target を持つ trigger が PC/SP 両方に存在するケースがあるため
        // 全て is-active にする (以前は querySelector で最初の1つだけだった)
        block.querySelectorAll(
          `.${ triggerClass }[data-target="${ initialActive.id }"]`
        ).forEach( ( t ) => t.classList.add( 'is-active' ) );
      }

      triggers.forEach( ( trigger ) => {
        trigger.addEventListener( 'click', () => {
          const target = trigger.dataset.target;
          if ( !target ) return;
          activate( target );
          // 指定ブロックはクリック後に自ブロック先頭へスクロール (Lenis 優先)
          if ( SCROLL_TO_BLOCKS.has( blockName ) ) {
            if ( LenisController.lenis ) {
              LenisController.lenis.scrollTo( block );
            } else {
              const y = block.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo( { top: y, behavior: 'smooth' } );
            }
          }
        } );
      } );
    } );
  },
};
